var _style, _g, _g2, _polygon, _polygon2, _g3, _polygon3, _g4, _polygon4, _polygon5, _g5, _polygon6, _g6, _g7, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgU2I(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 620.9 362.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st2{fill:#D5E04E;}\n\t.st3{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st4{fill:#00461B;}\n\t.st5{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st6{fill:#F2F5D5;}\n\t.st7{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\n\t.st8{fill:#92C83E;}\n\t.st9{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\n\t.st10{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\n\t.st11{fill:#3D913E;}\n\t.st12{clip-path:url(#SVGID_23_);fill:#101515;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "347.4 432.8 269.4 477.8 269.4 387.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 0.0011849,
    x2: 1.0012,
    y1: 595.43,
    y2: 595.43,
    gradientTransform: "matrix(41.846 65.838 65.838 -41.846 -38925 25300)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73BD43",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378E3E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "324.9 352.4 388.1 451.9 291.8 513.1 228.6 413.6",
    clipPath: "url(#SVGID_2_)",
    fill: "url(#SVGID_3_)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_4_",
    points: "347.4 342.7 269.4 387.7 269.4 297.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_4_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: -9.0949e-12,
    x2: 1,
    y1: 595.44,
    y2: 595.44,
    gradientTransform: "matrix(42.442 65.434 65.434 -42.442 -38676 25579)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73BD43",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378E3E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "324.3 262 388.5 361 292.5 423.3 228.2 324.3",
    clipPath: "url(#SVGID_5_)",
    fill: "url(#SVGID_6_)"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    transform: "translate(-111.33 -116.02)",
    points: "347.4 252.6 269.4 297.6 269.4 207.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    transform: "translate(-111.33 -116.02)",
    points: "347.4 162.5 269.4 207.5 269.4 117.5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_7_",
    points: "425.4 387.7 347.4 432.8 347.4 342.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_7_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    x1: 1.819e-12,
    x2: 1,
    y1: 595.42,
    y2: 595.42,
    gradientTransform: "matrix(38.855 67.668 67.668 -38.855 -39932 23474)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73BD43",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378E3E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "406 309 464.3 410.4 366.7 466.5 308.5 365",
    clipPath: "url(#SVGID_8_)",
    fill: "url(#SVGID_9_)"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    transform: "translate(-111.33 -116.02)",
    points: "269.4 387.7 347.4 342.7 347.4 432.8"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_10_",
    points: "425.4 297.6 347.4 342.7 347.4 252.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_10_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    x1: -5.457e-12,
    x2: 1,
    y1: 595.43,
    y2: 595.43,
    gradientTransform: "matrix(40.536 66.672 66.672 -40.536 -39342 24385)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C83E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C83E",
    offset: 0.01227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B149",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "404.3 218 465.4 318.4 368.4 377.3 307.4 276.9",
    clipPath: "url(#SVGID_11_)",
    fill: "url(#SVGID_12_)"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-111.33 -116.02)",
    points: "269.4 297.6 347.4 252.6 347.4 342.7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    transform: "translate(-111.33 -116.02)",
    points: "425.4 207.5 347.4 252.6 347.4 162.5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_13_",
    points: "269.4 207.5 347.4 162.5 347.4 252.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_13_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    x1: -1.1823e-11,
    x2: 1,
    y1: 595.14,
    y2: 595.14,
    gradientTransform: "matrix(36.982 68.682 68.682 -36.982 -40576 22201)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8C1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8C1",
    offset: 0.01227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BAB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "329.8 130 385 232.4 286.9 285.2 231.8 182.8",
    clipPath: "url(#SVGID_14_)",
    fill: "url(#SVGID_15_)"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    transform: "translate(-111.33 -116.02)",
    points: "347.4 342.6 425.4 297.6 425.4 387.7"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_16_",
    points: "347.4 252.6 425.4 207.5 425.4 297.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_16_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    x1: 9.0949e-12,
    x2: 1,
    y1: 595.13,
    y2: 595.13,
    gradientTransform: "matrix(40.002 66.976 66.976 -40.002 -39483 24042)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8C1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8C1",
    offset: 0.01227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BAB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "404.9 173.2 465.1 273.9 367.9 332 307.7 231.2",
    clipPath: "url(#SVGID_17_)",
    fill: "url(#SVGID_18_)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_19_",
    points: "191.3 162.5 269.4 117.5 269.4 207.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_19_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    x1: 4.5475e-12,
    x2: 1,
    y1: 595.14,
    y2: 595.14,
    gradientTransform: "matrix(37.792 68.252 68.252 -37.792 -40399 22638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8C1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8C1",
    offset: 0.01227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BAB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "251.1 84.4 307.5 186.4 209.7 240.6 153.2 138.6",
    clipPath: "url(#SVGID_20_)",
    fill: "url(#SVGID_21_)"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    transform: "translate(-111.33 -116.02)",
    points: "191.3 252.6 269.4 207.5 269.4 297.6"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    transform: "translate(-111.33 -116.02)",
    points: "191.3 342.7 269.4 297.6 269.4 387.7"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    transform: "translate(-111.33 -116.02)",
    points: "191.3 432.8 269.4 387.7 269.4 477.8"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    transform: "translate(-111.33 -116.02)",
    points: "113.3 207.5 191.3 162.5 191.3 252.6"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    transform: "translate(-111.33 -116.02)",
    points: "269.4 207.5 191.3 252.6 191.3 162.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    transform: "translate(-111.33 -116.02)",
    points: "113.3 297.6 191.3 252.6 191.3 342.7"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    transform: "translate(-111.33 -116.02)",
    points: "269.4 297.6 191.3 342.7 191.3 252.6"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    transform: "translate(-111.33 -116.02)",
    points: "113.3 387.7 191.3 342.7 191.3 432.8"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    transform: "translate(-111.33 -116.02)",
    points: "269.4 387.7 191.3 432.8 191.3 342.7"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    transform: "translate(-111.33 -116.02)",
    points: "191.3 252.6 113.3 297.7 113.3 207.6"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    transform: "translate(-111.33 -116.02)",
    points: "191.3 342.7 113.3 387.7 113.3 297.7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.33 -116.02)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_22_",
    width: 841.9,
    height: 595.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#SVGID_22_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m575.1 387.7h-8.9c-2 0-3.4-1.6-3.4-3.5v-3.4c-9.8 5.5-17.8 8.2-28.3 8.2-21.4 0-31-13.4-31-37.1v-58.6c0-2 1.6-3.6 3.6-3.6h8.6c2 0 3.6 1.6 3.6 3.6v58.6c0 18 6 23.6 19.6 23.6 7.5 0 15.9-2.9 24.1-7v-75.2c0-1.8 1.6-3.6 3.6-3.6h8.7c1.8 0 3.4 1.6 3.4 3.6v90.9c-0.3 1.9-1.7 3.5-3.6 3.5",
    clipPath: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m661.1 320.3-17.1 11.6c-19.8 13.4-25 22.4-25 38v3.7h60.1c1.9 0 3.6 1.1 3.6 3v7.9c0 2-1.6 3.2-3.6 3.2h-70.8c-1.9 0-3.6-1.4-3.6-3.4v-14.4c0-18.5 7.8-33.9 27.3-46.9l18-12.1c14.8-10 18.3-14.3 18.3-25 0-12.8-7.5-18.4-26.7-18.4-9.3 0-21.5 1.3-31.5 2.7h-0.7c-1.8 0-2.9-1.3-2.9-3.2v-6.2c0-1.8 1.6-2.9 3.4-3.2 9.1-2.3 21.2-3.6 31.7-3.6 28.9 0 42.6 10 42.6 31.9 0.1 14.1-6.5 23.2-23.1 34.4",
    clipPath: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m725 273.9h-9.1c-2 0-3.6-1.6-3.6-3.6v-14.2c0-2 1.6-3.6 3.6-3.6h9.1c2 0 3.6 1.6 3.6 3.6v14.2c-0.1 2.1-1.6 3.6-3.6 3.6m-0.4 113.8h-8.6c-2 0-3.5-1.6-3.5-3.5v-90.9c0-2 1.6-3.6 3.5-3.6h8.6c2 0 3.6 1.6 3.6 3.6v90.9c0 1.9-1.6 3.5-3.6 3.5",
    clipPath: "url(#SVGID_23_)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU2I);
export default __webpack_public_path__ + "static/media/u2i.3175490fe6e1e2ee1de8286b0e47a0ed.svg";
export { ForwardRef as ReactComponent };